import { Injectable } from '@angular/core';
import { DateTime as LuxonDateTime } from 'luxon';

@Injectable()
export class CalendarDay {

  async getBookJobStartDate(zone): Promise<string> {
    const timeNow = LuxonDateTime.fromObject({}, {
      zone,
    });

    const allowTimesToday = await this.checkIfAllowTimesToday(timeNow);

    if (allowTimesToday) {
      return timeNow.plus({days: 1}).toFormat('yyyy-MM-dd');
    } else {
      return timeNow.plus({days: 2}).toFormat('yyyy-MM-dd');
    }
  }

  checkIfAllowTimesToday(timeNow): Promise<any> {
    const checkDate = timeNow.set({'hour': 19, 'minute': 50});
    const minutesUntilLimit = checkDate.diff(timeNow, 'minutes').toObject().minutes;

    return Promise.resolve(minutesUntilLimit > 0);
  }

  addDays(date, days) {
    return LuxonDateTime.fromFormat(date, 'yyyy-MM-dd').plus({ days }).toFormat('yyyy-MM-dd');
  }

  getEndDay(startDate) {
    return this.addDays(startDate, 28);
  }
}
